<template>
  <v-container fluid>
    <v-data-table :headers="headers" :items="items">
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevo()" v-if="items.length == 0">
            Nuevo
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon @click="editar(item)"> fa-solid fa-pen-to-square </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title>Turno</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="nombre"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="hora"
                outlined
                dense
                hide-details
                type="time"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="crearCorte()" v-if="bandera == 0"
            >Guardar</v-btn
          >
          <v-btn color="primary" @click="actualizar()" v-if="bandera == 1"
            >Actualizar</v-btn
          >
          <v-btn color="red" @click="eliminar()" dark v-if="bandera == 1"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    headers: [
      { text: "Turno", value: "descripcion" },
      { text: "Hora", value: "hora" },
      { text: "Editar", value: "action_edit" },
    ],
    items: [],
    dialog: false,
    bandera: 0,
    id_configuracion_corte: "",
    id_empresa: "",
    nombre: "",
    hora: "",
  }),
  created() {
    this.listar();
  },
  methods: {
    listar() {
      axios
        .get(
          "api/ConfiguracionCortes/Listar/" + this.$store.state.emp.id_empresa
        )
        .then((response) => {
          //console.log(response.data);
          this.items = response.data;
        });
    },
    nuevo() {
      this.dialog = true;
      this.bandera = 0;
    },
    crearCorte() {
      axios
        .post("api/ConfiguracionCortes/Crear", {
          id_empresa: this.$store.state.emp.id_empresa,
          descripcion: this.nombre,
          hora: this.hora,
        })
        .then(() => {
          //console.log(response.data);
          this.cerrarDialog();
          this.listar();
        });
    },
    actualizar() {
      axios
        .put("api/ConfiguracionCortes/Actualizar", {
          id_configuracion_corte: this.id_configuracion_corte,
          id_empresa: this.$store.state.emp.id_empresa,
          descripcion: this.nombre,
          hora: this.hora,
        })
        .then(() => {
          this.cerrarDialog();
          this.listar();
        });
    },
    eliminar() {
      axios
        .delete(
          "api/ConfiguracionCortes/Eliminar/" + this.id_configuracion_corte
        )
        .then(() => {
          this.cerrarDialog();
          this.listar();
        });
    },
    editar(item) {
      //console.log(item);
      this.id_configuracion_corte = item.id_configuracion_corte;
      this.id_empresa = item.id_empresa;
      this.nombre = item.descripcion;
      this.hora = item.hora;
      this.dialog = true;
      this.bandera = 1;
    },
    cerrarDialog() {
      this.dialog = false;
      this.nombre = "";
      this.hora = "";
    },
  },
};
</script>